import './FilterBar.css';

export default function FilterBar({
  filters,
  search,
  onChange,
  onSearchChange,
  onClear,
  hasActiveFilters,
}) {
  return (
    <div className="filter-bar">
      <div className="filter-bar-controls">
        {filters.map(filter => (
          <div key={filter.key} className="filter-group">
            <span className="filter-group-label">{filter.label}</span>
            <div className="filter-pills" role="group" aria-label={`Filter by ${filter.label}`}>
              {filter.options.map(option => (
                <button
                  key={option}
                  type="button"
                  className={`filter-pill${filter.value === option ? ' filter-pill--active' : ''}`}
                  aria-pressed={filter.value === option}
                  onClick={() => onChange(filter.key, option)}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
        ))}

        {search && (
          <div className="filter-group filter-group--search">
            <label className="filter-group-label" htmlFor="filter-search-input">
              Search
            </label>
            <input
              id="filter-search-input"
              type="search"
              className="filter-search-input"
              value={search.value}
              placeholder={search.placeholder}
              onChange={e => onSearchChange(e.target.value)}
            />
          </div>
        )}
      </div>

      {hasActiveFilters && (
        <button type="button" className="filter-clear-btn" onClick={onClear}>
          Clear filters
        </button>
      )}
    </div>
  );
}
